import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { FEATURE_RECAPTCHA } from "../config/app.config";
import type { IncomingRegistrationConfig } from "../views/publicPages/RegisterV3/utils/registrationConfig";

interface NewGridData {
    startRow?: number;
    endRow?: number;
}

export interface FeatureFlags {
    recaptcha: boolean;
}

export interface UiReducerState {
    tenantLogoUrl: string | null;
    tenantTitleIconUrl: string | null;
    tenantDarkLogoUrl: string | null;
    tenantDarkTitleIconUrl: string | null;
    activePageName: string;
    googlePlacesApiKey: string;
    refreshGrid?: boolean;
    newGridData?: NewGridData;
    activeUiTabResourceId?: string;
    showBlockingModal: boolean;
    publicTenantData: any;
    publicRegistrationFlowConfig: IncomingRegistrationConfig | null;
    refreshMyWorkflowList?: boolean;
    subdomain: string;
    refreshActionItems?: boolean;
    featureFlags: FeatureFlags;
}

const initialState: UiReducerState = {
    tenantLogoUrl: null,
    tenantTitleIconUrl: null,
    tenantDarkLogoUrl: null,
    tenantDarkTitleIconUrl: null,
    activePageName: "",
    googlePlacesApiKey: "",
    activeUiTabResourceId: "",
    showBlockingModal: false,
    publicTenantData: {},
    publicRegistrationFlowConfig: null,
    refreshMyWorkflowList: true,
    subdomain: "",
    refreshActionItems: false,
    featureFlags: {
        recaptcha: FEATURE_RECAPTCHA,
    },
};

const uiSlice = createSlice({
    initialState,
    name: "uiSlice",
    reducers: {
        setSubdomain(state, action: PayloadAction<string>) {
            return { ...state, subdomain: action.payload };
        },
        showBlockingModal(state, action: PayloadAction<boolean>) {
            return { ...state, showBlockingModal: action.payload };
        },
        forceRefreshMyWorkflows(state) {
            return { ...state, refreshMyWorkflowList: !state.refreshMyWorkflowList };
        },
        setTenantLogoUrl(state, action: PayloadAction<string | null>) {
            return { ...state, tenantLogoUrl: action.payload };
        },
        setTenantTitleIconUrl(state, action: PayloadAction<string | null>) {
            return { ...state, tenantTitleIconUrl: action.payload };
        },
        setTenantDarkLogoUrl(state, action: PayloadAction<string | null>) {
            return { ...state, tenantDarkLogoUrl: action.payload };
        },
        setTenantDarkTitleIconUrl(state, action: PayloadAction<string | null>) {
            return { ...state, tenantDarkTitleIconUrl: action.payload };
        },
        setNewGridDataFetched(state, action: PayloadAction<NewGridData>) {
            return { ...state, newGridData: action.payload };
        },
        setForceRefreshGrid(state, action: PayloadAction<boolean>) {
            return { ...state, refreshGrid: action.payload };
        },
        setActiveUiTabResourceId(state, action: PayloadAction<string>) {
            return { ...state, activeUiTabResourceId: action.payload };
        },
        setGooglePlacesApiKey(state, action: PayloadAction<string>) {
            return { ...state, googlePlacesApiKey: action.payload };
        },
        setActivePageName(state, action: PayloadAction<string>) {
            return { ...state, activePageName: action.payload };
        },
        setPublicTenantData(state, action: PayloadAction<any>) {
            return { ...state, publicTenantData: action.payload };
        },
        setPublicRegistrationFlowConfig(state, action: PayloadAction<IncomingRegistrationConfig | null>) {
            return { ...state, publicRegistrationFlowConfig: action.payload };
        },
        setRefreshActionItems(state) {
            return { ...state, refreshActionItems: !state.refreshActionItems };
        },
    },
});

export const uiActions = uiSlice.actions;
export default uiSlice.reducer;
